import api from '@/api'
import * as types from '../mutation-types'

// initial state
const state = {
  all: null
}

// getters
const getters = {
  getAllProgramStudiData: state => state
}

// actions
const actions = {
  getAllProgramStudi ({ commit }) {
    api.get('/v1/public/program_studi')
      .then(response => {
        let responseData = response.data
        commit(types.PROGRAM_STUDI_RECIEVE, responseData.data)
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        console.log(e)
      })
  }
}

// mutations
const mutations = {
  [types.PROGRAM_STUDI_RECIEVE] (state, response) {
    state.all = response
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/program-studi.js